export const ANALYTICS_EVENT_NAME = {
  BUTTON_CLICKED: 'Button Clicked',
  COMPONENT_VIEWED: 'Component Viewed',
  DONATE_CTA_CLICKED: 'Donate CTA Clicked',
  EXPERIMENT_VIEWED: 'Experiment Viewed',
  VALUE_SELECTED: 'Value Selected',
  LINK_CLICKED: 'Link Clicked',
  SHARE: 'Share'
};